import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { item, length, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { Faq_AdminFaq, Faq_AdminFaq_$reflection, Faq_AdminFaqListItem_$reflection, Faq_AdminFaqKategorieListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { list_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Loaded, errorCmd, request, postEmpty } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { Remote$1 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { EditModel as EditModel_8, EditModel_Init, Msg, Model } from "./Types.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { value as value_9, map } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { update } from "../../../../Bfs.Web.Portale/Validation.fs.js";
import { Markdown_ToHtml_1BFEAEDB } from "../../../fable_modules/Fable.Formatting.Markdown.1.0.1/Markdown.fs.js";
import { parse } from "../../../fable_modules/fable-library-js.4.19.0/Int32.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";

export function Http_getKategorienList() {
    const response = fetch("/api/admin/faq/kategorien", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(Faq_AdminFaqKategorieListItem_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getFaqList(kategorieId) {
    const response = fetch(toText(printf("/api/admin/faq?kategorieId=%O"))(kategorieId), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(Faq_AdminFaqListItem_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getFaq(id) {
    const response = fetch(toText(printf("/api/admin/faq/%O"))(id), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Faq_AdminFaq_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postFaq(id, faq) {
    return sendJson(toText(printf("/api/admin/faq/%O"))(id), toString(0, Auto_generateBoxedEncoder_437914C6(Faq_AdminFaq_$reflection(), undefined, undefined, undefined)(faq)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function Http_postActivate(id) {
    let arg;
    return postEmpty((arg = encodeURIComponent(id), toText(printf("/api/admin/faq/%s/active"))(arg)));
}

export function Http_postDeactivate(id) {
    let arg;
    return postEmpty((arg = encodeURIComponent(id), toText(printf("/api/admin/faq/%s/inactive"))(arg)));
}

export function State_init(page, user, lastModel) {
    return [new Model(empty(), undefined, new Remote$1(1, []), undefined), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    let msg_1, matchValue, msg_3, bind$0040, bind$0040_1, bind$0040_2, bind$0040_3, bind$0040_4;
    let matchResult, kategorien, ex, kategorieId_1, faqs, id_2, id_4, id_7, faq, exn_1, kategorieId_5, value, value_1, value_2, id_11, value_3, value_4, value_5, value_6, value_7, e_12, id_15, e_13;
    switch (msg.tag) {
        case 1: {
            if (msg.fields[0].tag === 1) {
                matchResult = 2;
                ex = msg.fields[0].fields[0];
            }
            else {
                matchResult = 1;
                kategorien = msg.fields[0].fields[0];
            }
            break;
        }
        case 2: {
            matchResult = 3;
            kategorieId_1 = msg.fields[0];
            break;
        }
        case 3: {
            matchResult = 4;
            faqs = msg.fields[0];
            break;
        }
        case 4: {
            matchResult = 5;
            id_2 = msg.fields[0];
            break;
        }
        case 5: {
            matchResult = 6;
            id_4 = msg.fields[0];
            break;
        }
        case 6: {
            matchResult = 7;
            break;
        }
        case 8: {
            matchResult = 8;
            id_7 = msg.fields[0];
            break;
        }
        case 9: {
            if (msg.fields[0].tag === 1) {
                matchResult = 10;
                exn_1 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 9;
                faq = msg.fields[0].fields[0];
            }
            break;
        }
        case 7: {
            matchResult = 11;
            kategorieId_5 = msg.fields[0];
            break;
        }
        case 10: {
            matchResult = 12;
            value = msg.fields[0];
            break;
        }
        case 11: {
            matchResult = 13;
            value_1 = msg.fields[0];
            break;
        }
        case 12: {
            matchResult = 14;
            value_2 = msg.fields[0];
            break;
        }
        case 14: {
            matchResult = 15;
            id_11 = msg.fields[0];
            break;
        }
        case 13: {
            matchResult = 16;
            value_3 = msg.fields[0];
            break;
        }
        case 15: {
            matchResult = 17;
            value_4 = msg.fields[0];
            break;
        }
        case 16: {
            matchResult = 18;
            value_5 = msg.fields[0];
            break;
        }
        case 17: {
            matchResult = 19;
            value_6 = msg.fields[0];
            break;
        }
        case 18: {
            matchResult = 20;
            value_7 = msg.fields[0];
            break;
        }
        case 19: {
            if (model.EditModel != null) {
                matchResult = 21;
            }
            else {
                matchResult = 26;
            }
            break;
        }
        case 20: {
            if (msg.fields[0].tag === 1) {
                if (model.EditModel != null) {
                    matchResult = 23;
                    e_12 = msg.fields[0].fields[0];
                }
                else {
                    matchResult = 26;
                }
            }
            else if (model.EditModel != null) {
                matchResult = 22;
            }
            else {
                matchResult = 26;
            }
            break;
        }
        case 21: {
            if (msg.fields[0].tag === 1) {
                if (model.EditModel != null) {
                    matchResult = 25;
                    e_13 = msg.fields[0].fields[0];
                }
                else {
                    matchResult = 26;
                }
            }
            else if (model.EditModel != null) {
                matchResult = 24;
                id_15 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 26;
            }
            break;
        }
        case 22: {
            matchResult = 27;
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return [model, request(Http_getKategorienList, undefined, (Item) => (new Msg(1, [Item])))];
        case 1: {
            const selected = (length(kategorien) >= 1) ? item(0, kategorien).Id : undefined;
            return [new Model(kategorien, selected, model.Faqs, model.EditModel), (selected != null) ? ((msg_1 = (new Msg(2, [selected])), singleton((dispatch) => {
                dispatch(msg_1);
            }))) : Cmd_none()];
        }
        case 2:
            return [model, errorCmd((Item_1) => (new Msg(22, [Item_1])), "Kategorien laden", ex)];
        case 3:
            return [new Model(model.Kategorien, kategorieId_1, new Remote$1(1, []), undefined), request(Http_getFaqList, kategorieId_1, (Item_2) => (new Msg(3, [Item_2])))];
        case 4:
            return [new Model(model.Kategorien, model.SelectedKategorie, Loaded(faqs), model.EditModel), Cmd_none()];
        case 5:
            return [model, request(Http_postActivate, id_2, (Item_3) => (new Msg(6, [Item_3])))];
        case 6:
            return [model, request(Http_postDeactivate, id_4, (Item_4) => (new Msg(6, [Item_4])))];
        case 7:
            return [model, (matchValue = model.SelectedKategorie, (matchValue != null) ? ((msg_3 = (new Msg(2, [matchValue])), singleton((dispatch_1) => {
                dispatch_1(msg_3);
            }))) : Cmd_none())];
        case 8: {
            const cmd_4 = request(Http_getFaq, id_7, (Item_5) => (new Msg(9, [Item_5])));
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, EditModel_Init(id_7, "00000000-0000-0000-0000-000000000000")), cmd_4];
        }
        case 9:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, map((e_2) => (new EditModel_8(e_2.Id, update(e_2.Frage, faq.Frage), update(e_2.Antwort, faq.Antwort), update(e_2.Position, int32ToString(faq.Position)), faq.Aktiv, faq.SichtbarFuerPflege, faq.SichtbarFuerPflegeDtaPlus, faq.SichtbarFuerTherapie, faq.SichtbarFuerJugendhilfe, faq.KundenportalFaqKategorieId, e_2.Sending, false, Markdown_ToHtml_1BFEAEDB(faq.Antwort))), model.EditModel)), Cmd_none()];
        case 10:
            return [model, errorCmd((Item_6) => (new Msg(22, [Item_6])), "Laden", exn_1)];
        case 11: {
            const em_1 = EditModel_Init(undefined, kategorieId_5);
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, new EditModel_8(em_1.Id, update(em_1.Frage, "Neue Frage"), em_1.Antwort, em_1.Position, true, em_1.SichtbarFuerPflege, em_1.SichtbarFuerPflegeDtaPlus, em_1.SichtbarFuerTherapie, em_1.SichtbarFuerJugendhilfe, em_1.KategorieId, em_1.Sending, true, em_1.TextAsHtml)), Cmd_none()];
        }
        case 12:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, map((e_3) => (new EditModel_8(e_3.Id, update(e_3.Frage, value), e_3.Antwort, e_3.Position, e_3.Aktiv, e_3.SichtbarFuerPflege, e_3.SichtbarFuerPflegeDtaPlus, e_3.SichtbarFuerTherapie, e_3.SichtbarFuerJugendhilfe, e_3.KategorieId, e_3.Sending, true, e_3.TextAsHtml)), model.EditModel)), Cmd_none()];
        case 13:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, map((e_4) => (new EditModel_8(e_4.Id, e_4.Frage, update(e_4.Antwort, value_1), e_4.Position, e_4.Aktiv, e_4.SichtbarFuerPflege, e_4.SichtbarFuerPflegeDtaPlus, e_4.SichtbarFuerTherapie, e_4.SichtbarFuerJugendhilfe, e_4.KategorieId, e_4.Sending, true, Markdown_ToHtml_1BFEAEDB(value_1))), model.EditModel)), Cmd_none()];
        case 14:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, map((e_5) => (new EditModel_8(e_5.Id, e_5.Frage, e_5.Antwort, update(e_5.Position, value_2), e_5.Aktiv, e_5.SichtbarFuerPflege, e_5.SichtbarFuerPflegeDtaPlus, e_5.SichtbarFuerTherapie, e_5.SichtbarFuerJugendhilfe, e_5.KategorieId, e_5.Sending, true, e_5.TextAsHtml)), model.EditModel)), Cmd_none()];
        case 15:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, map((e_6) => (new EditModel_8(e_6.Id, e_6.Frage, e_6.Antwort, e_6.Position, e_6.Aktiv, e_6.SichtbarFuerPflege, e_6.SichtbarFuerPflegeDtaPlus, e_6.SichtbarFuerTherapie, e_6.SichtbarFuerJugendhilfe, id_11, e_6.Sending, true, e_6.TextAsHtml)), model.EditModel)), Cmd_none()];
        case 16:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, map((e_7) => (new EditModel_8(e_7.Id, e_7.Frage, e_7.Antwort, e_7.Position, value_3, e_7.SichtbarFuerPflege, e_7.SichtbarFuerPflegeDtaPlus, e_7.SichtbarFuerTherapie, e_7.SichtbarFuerJugendhilfe, e_7.KategorieId, e_7.Sending, true, e_7.TextAsHtml)), model.EditModel)), Cmd_none()];
        case 17:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, map((e_8) => (new EditModel_8(e_8.Id, e_8.Frage, e_8.Antwort, e_8.Position, e_8.Aktiv, value_4, e_8.SichtbarFuerPflegeDtaPlus, e_8.SichtbarFuerTherapie, e_8.SichtbarFuerJugendhilfe, e_8.KategorieId, e_8.Sending, true, e_8.TextAsHtml)), model.EditModel)), Cmd_none()];
        case 18:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, map((e_9) => (new EditModel_8(e_9.Id, e_9.Frage, e_9.Antwort, e_9.Position, e_9.Aktiv, e_9.SichtbarFuerPflege, value_5, e_9.SichtbarFuerTherapie, e_9.SichtbarFuerJugendhilfe, e_9.KategorieId, e_9.Sending, true, e_9.TextAsHtml)), model.EditModel)), Cmd_none()];
        case 19:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, map((e_10) => (new EditModel_8(e_10.Id, e_10.Frage, e_10.Antwort, e_10.Position, e_10.Aktiv, e_10.SichtbarFuerPflege, e_10.SichtbarFuerPflegeDtaPlus, value_6, e_10.SichtbarFuerJugendhilfe, e_10.KategorieId, e_10.Sending, true, e_10.TextAsHtml)), model.EditModel)), Cmd_none()];
        case 20:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, map((e_11) => (new EditModel_8(e_11.Id, e_11.Frage, e_11.Antwort, e_11.Position, e_11.Aktiv, e_11.SichtbarFuerPflege, e_11.SichtbarFuerPflegeDtaPlus, e_11.SichtbarFuerTherapie, value_7, e_11.KategorieId, e_11.Sending, true, e_11.TextAsHtml)), model.EditModel)), Cmd_none()];
        case 21: {
            const faq_1 = new Faq_AdminFaq(value_9(model.EditModel).Frage.Value, value_9(model.EditModel).Antwort.Value, parse(value_9(model.EditModel).Position.Value, 511, false, 32), value_9(model.EditModel).Aktiv, value_9(model.EditModel).SichtbarFuerPflege, value_9(model.EditModel).SichtbarFuerPflegeDtaPlus, value_9(model.EditModel).SichtbarFuerTherapie, value_9(model.EditModel).SichtbarFuerJugendhilfe, value_9(model.EditModel).KategorieId);
            let cmd_5;
            const matchValue_1 = value_9(model.EditModel).Id;
            cmd_5 = ((matchValue_1 == null) ? request((faq_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (sendJson("/api/admin/faq", toString(0, Auto_generateBoxedEncoder_437914C6(Faq_AdminFaq_$reflection(), undefined, undefined, undefined)(faq_3)), singleton(new Types_RequestProperties(4, ["include"])), "PUT").then((_arg) => (_arg.json().then((_arg_1) => (Promise.resolve(_arg_1)))))))), faq_1, (Item_8) => (new Msg(21, [Item_8]))) : request((tupledArg) => Http_postFaq(tupledArg[0], tupledArg[1]), [matchValue_1, faq_1], (Item_7) => (new Msg(20, [Item_7]))));
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, (bind$0040 = value_9(model.EditModel), new EditModel_8(bind$0040.Id, bind$0040.Frage, bind$0040.Antwort, bind$0040.Position, bind$0040.Aktiv, bind$0040.SichtbarFuerPflege, bind$0040.SichtbarFuerPflegeDtaPlus, bind$0040.SichtbarFuerTherapie, bind$0040.SichtbarFuerJugendhilfe, bind$0040.KategorieId, true, bind$0040.IsDirty, bind$0040.TextAsHtml))), cmd_5];
        }
        case 22:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, (bind$0040_1 = value_9(model.EditModel), new EditModel_8(bind$0040_1.Id, bind$0040_1.Frage, bind$0040_1.Antwort, bind$0040_1.Position, bind$0040_1.Aktiv, bind$0040_1.SichtbarFuerPflege, bind$0040_1.SichtbarFuerPflegeDtaPlus, bind$0040_1.SichtbarFuerTherapie, bind$0040_1.SichtbarFuerJugendhilfe, bind$0040_1.KategorieId, false, false, bind$0040_1.TextAsHtml))), Cmd_none()];
        case 23:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, (bind$0040_2 = value_9(model.EditModel), new EditModel_8(bind$0040_2.Id, bind$0040_2.Frage, bind$0040_2.Antwort, bind$0040_2.Position, bind$0040_2.Aktiv, bind$0040_2.SichtbarFuerPflege, bind$0040_2.SichtbarFuerPflegeDtaPlus, bind$0040_2.SichtbarFuerTherapie, bind$0040_2.SichtbarFuerJugendhilfe, bind$0040_2.KategorieId, false, bind$0040_2.IsDirty, bind$0040_2.TextAsHtml))), errorCmd((Item_9) => (new Msg(22, [Item_9])), "Speichern", e_12)];
        case 24:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, (bind$0040_3 = value_9(model.EditModel), new EditModel_8(id_15, bind$0040_3.Frage, bind$0040_3.Antwort, bind$0040_3.Position, bind$0040_3.Aktiv, bind$0040_3.SichtbarFuerPflege, bind$0040_3.SichtbarFuerPflegeDtaPlus, bind$0040_3.SichtbarFuerTherapie, bind$0040_3.SichtbarFuerJugendhilfe, bind$0040_3.KategorieId, false, false, bind$0040_3.TextAsHtml))), Cmd_none()];
        case 25:
            return [new Model(model.Kategorien, model.SelectedKategorie, model.Faqs, (bind$0040_4 = value_9(model.EditModel), new EditModel_8(bind$0040_4.Id, bind$0040_4.Frage, bind$0040_4.Antwort, bind$0040_4.Position, bind$0040_4.Aktiv, bind$0040_4.SichtbarFuerPflege, bind$0040_4.SichtbarFuerPflegeDtaPlus, bind$0040_4.SichtbarFuerTherapie, bind$0040_4.SichtbarFuerJugendhilfe, bind$0040_4.KategorieId, false, bind$0040_4.IsDirty, bind$0040_4.TextAsHtml))), errorCmd((Item_10) => (new Msg(22, [Item_10])), "Speichern", e_13)];
        case 26:
            return [model, Cmd_none()];
        default:
            return [model, Cmd_none()];
    }
}

//# sourceMappingURL=State.fs.js.map
